import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { List } from 'lodash';
import { Observable, of } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { EventDownloadPaymentScheduleCSV } from '../../models/event-download-payment-schedule-csv.model';
import {
  EventMilestone2PaymentBatchEvents,
  EventMilestone2PaymentBatchDetails,
  EventMilestone2PaymentBatch
} from '../../models/event-milestone2-payment-batch-events.model';
import { EventPaymentBatchDetails } from '../../models/event-payment-batch-details.model';
import { EventPaymentBatchEvent } from '../../models/event-payment-batch-event.model';
import { EventPaymentBatchList } from '../../models/event-payment-batch-list.model';
import { EventPaymentBatchStatusDropDown } from '../../models/event-payment-batch-status.model';
import { SettingsService } from '../common/settings.service';
import { EventsApiBase } from '../mcap-events/api-base';

@Injectable({
  providedIn: 'root'
})
export class EventPaymentScheduleService extends EventsApiBase {
  constructor(
    public override http: HttpClient,
    public settings: SettingsService
  ) {
    super(http, settings);
  }

  getAllEventPaymentBatch(): Observable<EventPaymentBatchList[]> {
    return this.get<EventPaymentBatchList[]>(
      'api/EventPaymentSchedule/GetAllEventPaymentBatch',
      {}
    ) as Observable<EventPaymentBatchList[]>;
  }

  getPaymentScheduleEventDetails(
    programTypeGuid: string
  ): Observable<EventPaymentBatchEvent[]> {
    return this.http.get<EventPaymentBatchEvent[]>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetPaymentScheduleEventDetails/' +
        programTypeGuid
    );
  }

  getPaymentBatchEventDetails(
    pbName: string,
    programTypeId: number
  ): Observable<EventPaymentBatchDetails> {
    return this.http.get<EventPaymentBatchDetails>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetAllPaymentBatchEvents/eventPaymentBatch/' +
        pbName +
        '?programTypeId=' +
        programTypeId
    );
  }

  getPaymentBatchStatus(): Observable<EventPaymentBatchStatusDropDown[]> {
    return this.http.get<EventPaymentBatchStatusDropDown[]>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetEventPaymentBatchStatus'
    );
  }

  createPaymentBatch(createpb: EventPaymentBatchDetails) {
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/SubmitEventPaymentBatch',
      createpb
    );
  }

  updatePaymentBatch(editpb: EventPaymentBatchDetails) {
    return this.http.patch<any>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/UpdateEventPaymentBatch/' +
        editpb.paymentScheduleBatch?.eventPaymentBatchScheduleId,
      editpb
    );
  }

  UpdateCancelledPaymentBatchEventDetails(
    cancelledEvents: EventPaymentBatchDetails
  ) {
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/UpdateCancelledPaymentBatchEventDetails',
      cancelledEvents
    );
  }

  getDownloadCSVFile(): Observable<EventDownloadPaymentScheduleCSV[]> {
    return of([]) as Observable<EventDownloadPaymentScheduleCSV[]>;
  }

  getDownloadCSVFileEdit(): Observable<EventDownloadPaymentScheduleCSV[]> {
    return of([]) as Observable<EventDownloadPaymentScheduleCSV[]>;
  }

  downloadExportPoeCSV(selectedID: any[]) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/DownloadPOESurveyDocs',
      selectedID,
      { headers, responseType: 'blob' }
    );
  }
  createAttendeeCSV(selectedEvents: List<number>, pbName: string) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetEventDetailsForExport/' +
        pbName,
      selectedEvents,
      { headers, responseType: 'blob' }
    );
  }
  downloadExportPoeDocuments(selectedID: any[]) {
    const headers = new HttpHeaders();
    return this.http.post(
      this.settings.baseEventsUrl + 'api/EventPaymentSchedule/DownloadPOEDocs',
      selectedID,
      { headers, responseType: 'blob' }
    );
  }

  getMilestone2PaymentScheduleEventDetails(
    programTypeGuid: string
  ): Observable<EventMilestone2PaymentBatchEvents[]> {
    return this.http.get<EventMilestone2PaymentBatchEvents[]>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetMilestone2PaymentScheduleEventDetails/' +
        programTypeGuid
    );
  }

  createMilestone2PaymentBatch(request: EventMilestone2PaymentBatchDetails) {
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/SubmitEventMilestone2PaymentBatch',
      request
    );
  }

  getMilestone2PaymentBatchEventDetails(
    pbName: string,
    programTypeGuid: string
  ): Observable<EventMilestone2PaymentBatch> {
    return this.http.get<EventMilestone2PaymentBatch>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/GetMilestone2PaymentBatchEvents/eventPaymentBatch/' +
        pbName +
        '/' +
        programTypeGuid
    );
  }

  updateEventMilestone2PaymentBatch(request: EventMilestone2PaymentBatch) {
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/EventPaymentSchedule/UpdateEventMilestone2PaymentBatch',
      request
    );
  }

  getAllM2EventPaymentBatch(
    programTypeGUID: string
  ): Observable<EventPaymentBatchList[]> {
    return this.http.get<EventPaymentBatchList[]>(
      this.settings.baseEventsUrl +
      'api/EventPaymentSchedule/GetAllEventMilestone2PaymentBatch/' +
        programTypeGUID
    );
  }
}
